import './index.css';
import './api/index';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';

import App from './App';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import { installGlobalErrorSink } from './util/errorSink';

// ISSUE-040: installed here, at module scope and BEFORE root.render, so that
// errors thrown during the very first render pass are already covered. Not
// from a component effect — <React.StrictMode> below mounts every effect
// twice, which would register both window listeners twice and record every
// error twice.
installGlobalErrorSink();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <BrowserRouter>
        {/* Last-resort boundary (ISSUE-004): catches render errors thrown
            above the per-page boundaries — the providers, JobEventsBridge and
            the router config itself. */}
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </BrowserRouter>
    </RecoilRoot>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
